export default __webpack_public_path__ + "static/media/a-3d1440.8a475746.svg";